import { createEvent } from '@/utils/apis/user-service';
import { useAuthStore } from '@/utils/stores/useAuthStore';
import { RELEASE_VERSION } from '@/utils/version';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { Event } from "../types/Event";

type EventInput = Omit<Event, 'source_page' | 'release_version' | 'user_id'>;

export function useCreateEvent() {
    const { auth } = useAuthStore()
    const userId = auth.userId
    const location = useLocation()
    const sourcePage = location.pathname

    const sendEvent = useCallback(async (eventData: EventInput & { user_id?: string }) => {
        const completeEvent: Event = {
            ...eventData,
            user_id: eventData.user_id || userId || undefined,
            source_page: sourcePage,
            release_version: RELEASE_VERSION,
        };
        try {
            const response = await createEvent(completeEvent);
            return response;
        } catch (error) {
            console.error("Failed to send event:", error);
            throw error;
        }
    }, []);

    return { sendEvent }
}